import { Dashboard } from "./Dashboard";
import { useParams } from "react-router-dom";
import { useWelderProfile } from "../hooks";

export function WelderDashboard() {
  const { id } = useParams();
  const welder = useWelderProfile(id);

  if (welder.isLoading) {
    return <p>Loading...</p>;
  } else if (welder.isError) {
    return <p>An unknown error occurred.</p>;
  } else if (welder.isSuccess) {
    return <Dashboard welder={welder.data} />;
  } else {
    return <p>Welder not found.</p>;
  }
}
